export default {
    namespaced: true,
    state: {
        totalInsuredAmount: 200000,
        departureDate: '',
        vno: '',
        vc: '2',
        payMoney: 20,
        isSaveUse: 1,
        isSamePerson: 1,
        mainOrderId: '',
        maxPremium: 0,
        minPremium: 0,
        balance: 0,
        driverInfoList: [{
            driverName: "",
            driverPhone: "",
        }],
        applicantInfoList: [{
            certificateType: '01',
            personnelType: '1',
            name: '',
            certificateNo: '',
            mobile: ''
        }],
        insurantInfoList: [{
            certificateType: '01',
            personnelType: '1',
            name: '',
            certificateNo: ''
        }],
        riskGroupInfoList: [{
            cargoType: '0',
            cargoName: '',
            carriageStartPlace: {
                province: '',
                city: '',
                county: '',
                provinceCode: '',
                cityCode: '',
                countyCode: ''
            },
            transferPlace: {
                province: '',
                city: '',
                county: '',
                provinceCode: '',
                cityCode: '',
                countyCode: ''
            },
            destination: {
                province: '',
                city: '',
                county: '',
                provinceCode: '',
                cityCode: '',
                countyCode: ''
            }
        }],
    },
    getters: {
        departure: state => {
            let info = state.riskGroupInfoList[0].carriageStartPlace;
            if (info.province) {
                return info.province + '-' + info.city + '-' + info.county;
            } else {
                return ''
            }
        },
        transit: state => {
            let obj = {};
            let info = state.riskGroupInfoList[0].transferPlace;
            if (info.province) {
                obj.context = info.province + '-' + info.city + '-' + info.county;
                obj.imgUrl = require('../assets/close.png');
                obj.size = '3.47vw';
            } else {
                obj.context = '';
                obj.imgUrl = require('../assets/down.png');
                obj.size = '2.67vw';
            }
            return obj;
        },
        destinationStr: state => {
            let info = state.riskGroupInfoList[0].destination;
            if (info.province) {
                return info.province + '-' + info.city + '-' + info.county;
            } else {
                return ''
            }
        },
        insuredIdType: state => {
            if (state.insurantInfoList[0].certificateType === '01') {
                return '身份证'
            } else {
                return '统一社会信用代码'
            }
        },
        amountPlaceHolder: state => {
            if (state.riskGroupInfoList[0].cargoType === '0' || state.riskGroupInfoList[0].cargoType === '-1') {
                return "请输入1-300"
            } else {
                return "请输入1-100"
            }
        }
    },
    mutations: {
        setPayMoney(state, money) {
            state.payMoney = money;
        },
        setMaxMoney(state, money) {
            state.maxPremium = money;
        },
        setMinMoney(state, money) {
            state.minPremium = money;
        },
        setGoodsType(state, type) {
            state.riskGroupInfoList[0].cargoType = type;
        },
        setGoodsName(state, name) {
            state.riskGroupInfoList[0].cargoName = name;
        },
        setDriverName(state, name) {
            state.driverInfoList[0].driverName = name;
        },
        setDriverPhone(state, phone) {
            state.driverInfoList[0].driverPhone = phone;
        },
        setAmount(state, amount) {
            state.totalInsuredAmount = amount;
        },
        setVehicleNo(state, vno) {
            state.vno = vno;
        },
        setDepartureDate(state, departureDate) {
            state.departureDate = departureDate;
        },
        setDeparture(state, data) {
            state.riskGroupInfoList[0].carriageStartPlace = data;
        },
        setTransit(state, data) {
            state.riskGroupInfoList[0].transferPlace = data;
        },
        setDestination(state, data) {
            state.riskGroupInfoList[0].destination = data;
        },
        setPersonType(state, type) {
            if (state.insurantInfoList[0].personnelType !== type) {
                state.insurantInfoList[0].personnelType = type;
                if (type === '1') {
                    //个人
                    state.insurantInfoList[0].certificateType = '01';
                } else {
                    //团体
                    state.insurantInfoList[0].certificateType = '03';
                }
            }
        },
        setName(state, name) {
            state.insurantInfoList[0].name = name.replace(/[• . .]/g, "·");
        },
        setCertificateNo(state, certificateNo) {
            state.insurantInfoList[0].certificateNo = certificateNo;
        },
        setSamePerson(state, type) {
            state.isSamePerson = type;
        },
        setScheme(state, type) {
            state.isSaveUse = type;
        },
        setApplicantInfoList(state, data) {
            state.applicantInfoList = data;
        },
        setInsuredInfoList(state, data) {
            state.insurantInfoList = data;
        },
        setRiskGroupInfo(state, data) {
            state.riskGroupInfoList = data;
        },
        setOrderId(state, orderId) {
            state.mainOrderId = orderId;
        },
        setBalance(state, balance) {
            state.balance = balance;
        }
    }
}